import React from 'react';
import PlatformFooter from 'cccisd-footer';
import style from './style.css';

const Footer = () => {
    return (
        <div className={style.lower}>
            <PlatformFooter />
        </div>
    );
};

export default Footer;
